import { useCallback } from "react";

import type { ReservationLocalCancelFeeRejectInput } from "@/lib/gql/__generated__/graphql";

import * as MutationRepository from "../../repository/mutation";

export const useUpdateReservationLocalCancelFeeTransferReject = (hotelID: string, reservationID: string) => {
	const { onUpdateReservationLocalCancelFeeTransferReject: _onUpdateReservationLocalCancelFeeTransferReject } =
		MutationRepository.useReservationLocalCancelFeeTransferRejectUpdateMutation();

	/**
	 * 予約詳細の現地決済の承認の否認への更新を実行
	 */
	const onUpdateReservationLocalCancelFeeTransferReject = useCallback(
		async (
			insufficientAmount: ReservationLocalCancelFeeRejectInput["insufficientAmount"],
			rejectReason: ReservationLocalCancelFeeRejectInput["rejectReason"],
		) => {
			const input: ReservationLocalCancelFeeRejectInput = {
				insufficientAmount,
				rejectReason,
				hotelID,
				reservationID,
			} satisfies ReservationLocalCancelFeeRejectInput;
			return _onUpdateReservationLocalCancelFeeTransferReject(input);
		},
		[_onUpdateReservationLocalCancelFeeTransferReject, hotelID, reservationID],
	);

	return {
		onUpdateReservationLocalCancelFeeTransferReject,
	};
};
